import styled from 'styled-components';
import { BouRadioButtonWithLabel } from '../../../common/generic/components/inputs/bou-radio-button-with-label';
import { getTitleStyle } from '../../../common/generic/content/texts/bou-title/title-style';
import { BouSpacingLevel, fluidSpacing } from '../../../common/generic/layout/bou-spacing';
import { fluidSpaceLg } from '../../../common/generic/utilities/fluid/fluid';

export const ComponenControlWrap = styled.div`
  display: flex;
`;

export const ControlRoot = styled.div`
  ${fluidSpacing('margin-bottom', BouSpacingLevel.SMALL)}
  ${fluidSpacing('margin-right', BouSpacingLevel.SMALL)}
  ${fluidSpaceLg('min-height', 120)}
`;

export const ControlRowLabel = styled.div`
  ${getTitleStyle({ size: 'h7', withMargin: true })}
`;

export const ControlRowContent = styled.div``;

export const ControlRowContentRow = styled.div`
  & + & {
    ${fluidSpacing('margin-top', BouSpacingLevel.TINY)}
  }
`;

export const RadioButtonsWrap = styled.div``;

export const RadioButton = styled(BouRadioButtonWithLabel)`
  & + & {
    ${fluidSpacing('margin-top', BouSpacingLevel.MICRO)}
  }
`;
